interface Props {
  color?: string
  width?: number
  height?: number
}

export const TextIcon = ({ color = '#6F6F6F', width = 22, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.7812 0C21.0573 0.000135563 21.2812 0.223941 21.2812 0.5V3.1748C21.2812 3.45084 21.0573 3.67467 20.7812 3.6748C20.5053 3.67459 20.2813 3.45079 20.2812 3.1748V1H11.1406V19.5215H15.7109C15.987 19.5216 16.2109 19.7454 16.2109 20.0215C16.2107 20.2974 15.9869 20.5214 15.7109 20.5215H5.57031C5.29432 20.5215 5.07056 20.2974 5.07031 20.0215C5.07031 19.7453 5.29417 19.5215 5.57031 19.5215H10.1406V1H1V3.1748C0.999976 3.45084 0.776012 3.67467 0.5 3.6748C0.223873 3.6748 2.45566e-05 3.45093 0 3.1748V0.5C0 0.223858 0.223858 0 0.5 0H20.7812Z"
        fill={color}
      />
    </svg>
  )
}
